import type { User } from '@/types/user';

/**
 * The paying-organization uuid for analytics. The `/v3/user` endpoint doesn't
 * return a standalone org uuid — it's the last segment of the org's urn
 * (`urn:vida:paying-organization:<uuid>`). Extracting it keeps the `paying_org`
 * value consistent with the bare-uuid the rest of Vida's analytics uses.
 * Returns `undefined` when the user has no paying organization.
 */
export const payingOrgUuid = (user: User): string | undefined => {
  const urn = user.payingOrganization?.urn;
  return urn ? urn.split(':').pop() : undefined;
};
